import { DELETE, EDIT } from "@utils/constants";

export const REMINDER_FORM_VIEW = "reminder_form";
export const REMINDER_RECURRENCE_VIEW = "reminder_recurrence";

export const REMINDER_RECURRENCE_DAILY = "daily";
export const REMINDER_RECURRENCE_WEEKLY = "weekly";
export const REMINDER_RECURRENCE_MONTHLY = "monthly";

export const WEEK_DAYS = [
    {
        label: "Sunday",
        value: 0,
    },
    {
        label: "Monday",
        value: 1,
    },
    {
        label: "Tuesday",
        value: 2,
    },
    {
        label: "Wednesday",
        value: 3,
    },
    {
        label: "Thursday",
        value: 4,
    },
    {
        label: "Friday",
        value: 5,
    },
    {
        label: "Saturday",
        value: 6,
    },
]

export const REMINDER_FREQUENCY_VALUES = [
    {
        label: "Daily",
        value: REMINDER_RECURRENCE_DAILY
    },
    {
        label: "Weekly",
        value: REMINDER_RECURRENCE_WEEKLY
    },
    {
        label: "Monthly",
        value: REMINDER_RECURRENCE_MONTHLY
    }
]

export const REMINDER_RECURRENCE_END_BY = "endBy";
export const REMINDER_RECURRENCE_END_AFTER = "endAfter";
export const REMINDER_RECURRENCE_NO_END_DATE = "noEndDate";

export const REMINDER_RECURRENCE_END = [
    {
        label: "End by",
        value: REMINDER_RECURRENCE_END_BY
    },
    {
        label: "End After",
        value: REMINDER_RECURRENCE_END_AFTER
    },
    // {
    //     label: "No End Date",
    //     value: REMINDER_RECURRENCE_NO_END_DATE
    // }
]
export const REMINDER_MONTH_WEEK = [
    {
        label: "First",
        value: 1
    },
    {
        label: "Second",
        value: 2
    },
    {
        label: "Third",
        value: 3
    },
    {
        label: "Fourth",
        value: 4
    },
    // {
    //     label: "Last",
    //     value: 5
    // },
];

export const CURRENT_ITEM = 'CURRENT ITEM';

export const ENTIRE_SERIES = 'ENTIRE SERIES';

export const ReminderRecurrenceModalContent: any = {
  [EDIT]: {
    title: "Open Recurring Item",
    body__title: "This is one appointment in a series. What do you want to open?",
    body__radio_group: [
      { label: "Just This One", value: false },
      { label: "The Entire Series", value: true },
    ],
    cancel__button_text: "Cancel",
    primary__button_text: "Open",
  },
  [DELETE]: {
    title: "Delete Recurring Item",
    body__title: "This is one appointment in a series. What do you want to delete?",
    body__radio_group: [
      { label: "Just This One", value: CURRENT_ITEM },
      { label: "The Entire Series", value: ENTIRE_SERIES },
    ],
    cancel__button_text: "Cancel",
    primary__button_text: "Delete",
  },
};
